<script>
    import store from "../../store";
    import SuccessInvite from "../onboarding/success/SuccessInvite";
    import SuccessModal from "../onboarding/success/SuccessModal";

    export default {
        name: "SuccessForm",

        props: {
            'invites' : {
                type: Array,
                required: true
            }
        },

        components: {
            SuccessInvite,
            SuccessModal
        },

        mounted() {
            store.commit('success/setInvites', this.invites);
        }
    }
</script>